import { useState, useEffect } from 'react';

const STORAGE_KEY = 'astrantis_timezone';
export const DEFAULT_TIMEZONE = 'Asia/Seoul';

export function getBrowserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TIMEZONE;
  } catch {
    return DEFAULT_TIMEZONE;
  }
}

export function getStoredTimezone() {
  try { return localStorage.getItem(STORAGE_KEY) || getBrowserTimezone(); } catch { return getBrowserTimezone(); }
}

export function getUserTimezone() {
  return getBrowserTimezone();
}

export function saveTimezone(tz) {
  try { localStorage.setItem(STORAGE_KEY, tz); } catch {}
  window.dispatchEvent(new StorageEvent('storage', { key: STORAGE_KEY, newValue: tz }));
}

/**
 * 메시지 시간 표시.
 * rawTimestamp가 "YYYY-MM-DD HH:MM:SS" 형식(시간대 없는 DB 문자열)이면 UTC로 해석한다.
 * 그 외(epoch ms, ISO+Z)는 사용자 설정 시간대로 포맷.
 *
 * @param {number|null} timestamp      epoch ms (그룹핑용)
 * @param {string}      timezone       e.g. 'Asia/Seoul'
 * @param {string|number|null} [rawTimestamp]  원본 값
 */
export function formatMessageTime(timestamp, timezone, rawTimestamp) {
  let value = timestamp;
  if (rawTimestamp != null) {
    const s = String(rawTimestamp);
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(s)) {
      value = new Date(`${s.replace(' ', 'T')}Z`).getTime();
    }
  }
  if (!value) return '';
  try {
    return new Intl.DateTimeFormat('ko-KR', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: timezone || DEFAULT_TIMEZONE,
    }).format(new Date(value));
  } catch {
    return new Date(value).toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit', hour12: false });
  }
}

/** 시간대 상태 훅 — storage 이벤트로 설정 변경 즉시 반영 */
export function useTimezone() {
  const [timezone, setTimezone] = useState(getUserTimezone);

  useEffect(() => {
    const handler = () => setTimezone(getUserTimezone());
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  return timezone;
}
